<template>
    <div :class="iconClass ? 'app-dropdown app-dropdown-with-icon ' + cssClass : 'app-dropdown ' + cssClass">
        <div v-if="iconClass" class="app-dropdown-icon">
            <i :class="iconClass"></i>
        </div>
        <div class="app-dropdown-list">
            <ejs-dropdownlist
                :id="id"
                :value="value"
                @change="onChange"
                :dataSource="dataSource"
                :fields="fields"
                :allowFiltering="allowFiltering"
                :filtering="filtering"
                :select="select"
                :created="created"
                :placeholder="placeholder"
                :cssClass="dropdownClass"
                :aria-label="ariaLabel"
                v-on="$listeners"
            >
                <slot></slot>
            </ejs-dropdownlist>
        </div>
    </div>
</template>

<script>
    export default {
    name: 'menu-dropdown',
    props: {
        value: null, // for v-model
        id: String,
        dataSource: [Array, Object],
        fields: Object,
        allowFiltering: Boolean,
        filtering: Function,
        select: Function,
        change: Function,
        created: Function,
        placeholder: String,
        dropdownClass: String,
        ariaLabel: String,
        iconClass: String,
        cssClass: String
    },
    methods: {
        onChange(e) {
            this.$emit('input', e.value);
            if (this.change) this.change(e);
        }
    }
}
</script>

<style scoped>
    .app-dropdown {
        position: relative;
    }

    .app-dropdown-icon {
        position: absolute;
        height: 100%;
        border-radius: 14px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        z-index: 1;
        width: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .app-dropdown-with-icon .app-dropdown-list > .e-input-group.e-control-wrapper input {
        padding-left: 48px;
        text-align: left;
    }

    .app-dropdown-with-icon .app-dropdown-list > .e-input-group.e-control-wrapper .e-input-group-icon.e-ddl-icon.e-search-icon {
        background-color: red;
        outline: none!important;
        box-shadow: 0 0 0 2px #C2E66E !important;
    }
</style>